import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { QueryClientWrapper } from '@/config/QueryClientWrapper.comp.tsx';
import { AppErrorBoundary } from '@/errorHandling/ErrorBoundary.comp.tsx';
import { ConfigInitializeController } from '@/layouts/controllers/ConfigInitialize.controller.tsx';
import { handleRouterError } from '@/monitoring/routerError.util.ts';
import { appRoutes } from '@/routes/appRoutes.tsx';

import { knowMeTheme } from './config/theme/theme.ts';

dayjs.extend(utc);

const nonce = document.querySelector("meta[property='csp-nonce']")?.getAttribute('content') ?? '';
const cache = createCache({
  key: 'css',
  nonce,
  prepend: true,
});

const router = createBrowserRouter(appRoutes);

function App() {
  return (
    <CacheProvider value={cache}>
      <LocalizationProvider adapterLocale="en-gb" dateAdapter={AdapterDayjs}>
        <ThemeProvider theme={knowMeTheme}>
          <AppErrorBoundary>
            <QueryClientWrapper>
              <ConfigInitializeController>
                <RouterProvider onError={handleRouterError} router={router} />
              </ConfigInitializeController>
            </QueryClientWrapper>
          </AppErrorBoundary>
        </ThemeProvider>
      </LocalizationProvider>
    </CacheProvider>
  );
}

export default App;
